<div class="flex flex-col gap-3 md:gap-4" [formGroup]="formGroup">
    <h2 class="text-base text-shui-text-strong font-semibold m-0 my-2 p-0">
        {{ 'request.select-deal-type' | translate }}
    </h2>
    <p class="text-sm text-shui-text-moderate m-0 p-0">
        {{ 'request.select-deal-type-description' | translate }}
    </p>
    <sh-radio-card class="block mt-4" formControlName="dealType">
        <sh-radio-card-item [value]="DealType.INSTRUMENT_ONLY">
            <div class="flex flex-col gap-4">
                <p class="text-base text-shui-text-strong m-0 p-0 font-semibold">
                    {{ 'request.deal-type-form.instrument-only' | translate }}
                </p>
                <p class="text-sm text-shui-text-strong m-0 p-0">
                    {{ 'request.deal-type-form.instrument-only-description' | translate }}
                </p>
                <ul class="m-0 p-0 pl-6">
                    <li class="text-sm text-shui-text-strong">
                        {{ 'request.deal-type-form.instrument-only-feature-1' | translate }}
                    </li>
                    <li class="text-sm text-shui-text-strong">
                        {{ 'request.deal-type-form.instrument-only-feature-2' | translate }}
                    </li>
                    <li class="text-sm text-shui-text-strong">
                        {{ 'request.deal-type-form.instrument-only-feature-3' | translate }}
                    </li>
                </ul>
            </div>
        </sh-radio-card-item>
        <sh-radio-card-item [value]="DealType.STANDARD_DEAL">
            <div class="flex flex-col gap-4">
                <p class="text-base text-shui-text-strong m-0 p-0 font-semibold">
                    {{ 'request.deal-type-form.standard-deal' | translate }}
                </p>
                <p class="text-sm text-shui-text-strong m-0 p-0">
                    {{ 'request.deal-type-form.standard-deal-description' | translate }}
                </p>
                <ul class="m-0 p-0 pl-6">
                    <li class="text-sm text-shui-text-strong">
                        {{ 'request.deal-type-form.standard-deal-feature-1' | translate }}
                    </li>
                    <li class="text-sm text-shui-text-strong">
                        {{ 'request.deal-type-form.standard-deal-feature-2' | translate }}
                    </li>
                    <li class="text-sm text-shui-text-strong">
                        {{ 'request.deal-type-form.standard-deal-feature-3' | translate }}
                    </li>
                </ul>
            </div>
        </sh-radio-card-item>
    </sh-radio-card>
</div>
